// extracted by mini-css-extract-plugin
module.exports = {"auctionWrapper":"_1ZN0-","text":"_1U473","auctionTime":"_1nonx","auctionTimeWraper":"_2_DOv","viewsCar":"_2qsR6","viewMap":"_1FSPE","timer":"_2BoFv"};